import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAllItemInventoryData, getAllReportsData } from "src/thunks/reports";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";
import { Monthly } from "./reportType/monthly";
import moment from "moment";
import _ from "lodash";

export const ReportList = () => {
    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
    const { allinventoryData, inventoryreportsDataLoading } = useSelector((state) => state.reports);
    const { filterAllData } = useSelector((state) => state.goodsin);

    /** Variable Declarations ----------------------------------------------------- **/
    const filterData = filterAllData["Inventrory"]
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const orderedClientList = _.orderBy(userDetails?.projects, ['clientName'], ["asc"])

    /** hooks useEffect----------------------------------------------------- **/
    useEffect(() => {
        getAllReportsDataFunc()
    }, [])

    /** Function to retrieve all reports data ------------------------ **/
    const getAllReportsDataFunc = async () => {
        try {
            let data = {
                isDateRange: false,
                from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
                DepotIds: [filterData?.depotId?.id || 0],
                ClientIds: [filterData?.clientId?.id || 0],
                ProjectIds: [filterData?.projectId?.id || 0],
            };
            if (filterData?.toDate) {
                data["isDateRange"] = true;
                data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
            }
            await dispatch(getAllItemInventoryData({ ...data }))
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    }

    if (inventoryreportsDataLoading) {
        return <Loader />;
    }

    /** If data not found in report shown no data found message ------------------- **/
    if (allinventoryData?.length === 0) {
        return <div style={{ display: "flex", width: "100%", justifyContent: "center", height: 500, alignItems: "center" }}>
            No Data found
        </div>
    }
    else
        return (
            <>
                <div className={`summaryReportMain ${isDropdownOpenFlagValue == true ? "add-overlay-for-depot-dropdown" : ""} rh-report`} >
                    <Monthly data={allinventoryData} />
                </div>

            </>
        )
};
